import forms from './forms.json';

export const FORMS = forms;
